"use client";

import { Plane } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const airports = [{
  code: "JFK",
  name: "John F. Kennedy International Airport",
  service: "VIP Meet-and-Greet",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/jfk_terminal_exterior.png"
}, {
  code: "LGA",
  name: "LaGuardia Airport",
  service: "Curbside Pickup",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/lga_terminal_entrance.png"
}, {
  code: "EWR",
  name: "Newark Liberty International Airport",
  service: "Luggage Assistance",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/ewr_terminal_view.png"
}, {
  code: "BDL",
  name: "Bradley International Airport",
  service: "Express Check-in Support",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/bdl_airport_terminal.png"
}, {
  code: "HPN",
  name: "Westchester County Airport",
  service: "Private Terminal Access",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/hpn_private_terminal.png"
}, {
  code: "TEB",
  name: "Teterboro Airport",
  service: "Executive Lounge Service",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/teb_executive_lounge.png"
}];
export default function ComprehensiveAirportCoverage() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section ref={sectionRef} className="relative bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
            Comprehensive Airport Coverage
          </h2>
          <p className="mt-4 text-lg text-foreground/80">
            Premium car service to all major airports in Connecticut, New York, and New Jersey
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {airports.map((airport, i) => {
          const delay = i * 150;
          return <Card key={airport.code} data-index={i} className={`group relative overflow-hidden rounded-lg border border-muted/20 bg-secondary shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: `${delay}ms`
          }}>
                <div className="relative h-48 bg-cover bg-center" style={{
              backgroundImage: `url(${airport.image})`
            }}>
                  <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm transition-all duration-[var(--duration-medium)] group-hover:bg-primary/70" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="flex flex-col items-center gap-2">
                      <Plane className="size-12 text-foreground-primary" strokeWidth={1.5} />
                      <span className="font-display text-2xl font-bold text-foreground-primary">
                        {airport.code}
                      </span>
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 translate-y-full bg-accent/95 px-4 py-3 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:translate-y-0">
                    
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg font-semibold text-foreground-secondary">
                    {airport.name}
                  </h3>
                </div>
              </Card>;
        })}
        </div>

        <div ref={ctaRef} className={`mt-12 flex justify-end transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${ctaVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
          <Link to="/AirportsWeServicePage">
            <Button className="btn-primary">
              View All Airports
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}